import './home.css';
import img from '../props/img2.jpg';
import Buttons from '../button/button';
import { BsMouse } from 'react-icons/bs';
import Qualifications from '../qualifications/qualifications';

function Home() {
  return (
   <div>
     <div id='home' className='container home-container'>
      <div className='logo'>
        <div className='hover-show'>
          <span className='circle'></span>
          <span className='circle'></span>
          <span className='circle'></span>
          <span className='circle'></span>
          <span className='circle'></span>
          <span className='circle'></span>
          <span className='circle'></span>
          <span className='circle'></span>
        </div>
        <img src={img} alt='' />
      </div>

      <a href='#footer' className='scroll-down'>
        <hr />
        <h5>scroll down</h5>
        <BsMouse className='scroll' />
        <hr />
      </a>

      <h2>
        <span>About Me</span> <br />
        <p>
        I am an FrontEnd Developer . i am a junior developer with good knowledge of frontend techniques. I love spending time on on this web development and i also love to work team or optimizing web app. I Learn more about this and explore my self.
        </p>
      </h2>

      <Buttons />
    </div>
      <Qualifications />
   </div>
  );
}

export default Home;
